import type { FaireProductEntity } from "../../entity_types/product";

export const p_xm4f4x52ww: FaireProductEntity = {
  token: "p_xm4f4x52ww",
  type: "product",
  name: "Woodstock Pocket Chakra Chime™",
  brandToken: "b_66wf2igxcf",
  brandName: "Woodstock Chimes",
  imageUrl: "https://cdn.faire.com/fastly/58f6adbd115807667cd0ed74a56dc956eb2070e5cd8526cc409f1d725adbc260.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bc19fdafcc86f588d8c178dc12153710388ee24fff69da24bd93fcd52aa7afe.jpeg",
    "https://cdn.faire.com/fastly/0b02dba71de24396427488711a44adef491fd9b2303169f0d425c66b48db54b1.jpeg",
    "https://cdn.faire.com/fastly/10d714adf303365302252e3ba658b661d0ea2760369518f5f0dc78efd4497595.jpeg"
  ],
  priceDollars: 12.47,
  description: "This chime must be purchased in bundles of 6 (6, 12, 18, 24...).\n\nThe seven stones of this wind chime are aligned in an ascending column, just as the seven chakras are aligned along the spine in the human body.\n\nWoodstock Chakra Chimes combine color and sound to underscore the ancient meaning of the major energy centers of the human body. Eastern Philosophy can often be difficult for the Western scientific mind to assimilate and yet, many of the eastern claims are being proven scientifically as the time-honored truths that they are. Read more about the seven chakras here.\n\nWoodstock Chakra Chimes are intended to remind us of the strength of mind over matter and, through sound, give us a small window into the balance of the physical and metaphysical.",
  tags: [],
  msrpDollars: 25.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:54.099Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
